export const icons = [
	"arrow",
	"bag",
	"bell",
	"close",
	"comment",
	"grid",
	"heart",
	"leftArrow",
	"lock",
	"moon",
	"nothing",
	"pen",
	"plus",
	"rightArrow",
	"share",
	"slider",
	"user"
] as const

export type IconType = (typeof icons)[number]